import Vue from 'vue';
import convertEventsFromApi from '@/helpers/convertEventsFromApi.ts';

export function setState(state, payload) {
  for (let key in payload) {
    if (payload.hasOwnProperty(key)) {
      Vue.set(state, key, payload[key]);
    }
  }
}

export function setEvents(state, events, eventField) {
  state[eventField] = events.map(convertEventsFromApi);
}

export function setArticles(state, articles) {
  state.articles = articles.map(item => {
    return {
      id: Number(item.id),
      code: String(item.url_code),
      title: String(item.title),
      littleThumb: String(item.images.littleThumb),
      middleThumb: String(item.images.middleThumb),
      text: String(item.text),
      desc: String(item.desc),
      view: Number(item.view),
      comments: Number(item.comments),
      event_type: String(item.event_type),
    };
  });
}

export function clearState(state) {
  for (let key of Object.keys(state)) {
    state[key] = null;
  }
}



// WEBPACK FOOTER //
// ./src/store/common/mutations.js